document.addEventListener("DOMContentLoaded", function() {

function CartMerge() {
    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            let cartitems = cart.items;
            let groupedItems = {};
            let idCounts = {};
            let duplicateIds = [];
            cartcount = cartitems.length;

            console.log(cartitems);
            var variant_name = '';
            cartitems.forEach(item => {
                if (idCounts[item.id]) {

                    variant_name = item.variant_title;

                    idCounts[item.id] += 1;
                    if (idCounts[item.id] == 2) {
                        duplicateIds.push(item.id);
                    }
                } else {
                    idCounts[item.id] = 1;
                }

                if (groupedItems[item.id]) {
                    groupedItems[item.id] += item.quantity;
                } else {
                    groupedItems[item.id] = item.quantity;
                }
                if (item.variant_title.includes("Swatch Sample") && groupedItems[item.id] > 1) {
               
                    // Reduce quantity to 1 if more than 1 exists
                    $.ajax({
                        type: 'POST',
                        url: '/cart/change.js',
                        data: {
                            id: parseInt(item.id),
                            quantity: 1 
                        },
                        dataType: 'json',
                        success: function() {
                            console.log("Swatch Sample quantity reduced to 1");
                            location.reload();
                        },
                        error: function() {
                            console.error("Error adjusting Swatch Sample quantity");
                        }
                    });
                }



              
            });

            console.log("Grouped Items with Total Quantity:", groupedItems);
            console.log("Duplicate IDs:", duplicateIds);

            if (duplicateIds.length > 0) {
                duplicateIds.forEach(id => {
                    let data_val = {
                        id: parseInt(id),
                        quantity: groupedItems[id],
                        // properties: {
                        //     Yards: parseFloat(groupedItems[id] / 4)
                        // }
                    };

                    console.log(data_val);
                    if (variant_name == "By the Yard") {
                        $.ajax({
                            type: 'POST',
                            url: '/cart/change.js',
                            data: {
                                id: parseInt(id),
                                quantity: 0
                            },
                            dataType: 'json',
                            success: function() {
                                localStorage.removeItem('reload');
                                $.ajax({
                                    type: 'POST',
                                    url: '/cart/add.js',
                                    data: data_val,
                                    dataType: 'json',
                                    success: function() {


                                        if (!localStorage.getItem('reload')) {
                                            localStorage.setItem("reload", "true");
                                            location.reload();
                                        }
                                    },
                                    error: function() {
                                        console.error("Error adding item to cart");
                                    }
                                });
                            },
                            error: function() {
                                console.error("Error removing item from cart");
                            }
                        });
                    }
                });
            } else {

                // localStorage.removeItem('reload-merge');

                cartitems.forEach(item => {

                    if (groupedItems[item.id]) {
                        groupedItems[item.id] += item.quantity;
                    } else {
                        groupedItems[item.id] = item.quantity;
                    }

                    let item_variant = item.variant_title;
                    // alert(item_variant);

                    let data_new = {
                        id: item.id,
                        quantity: item.quantity,
                        // properties: {
                        //     Yards: parseFloat(item.quantity / 4)
                        // }
                    };

                    var check = localStorage.getItem('reload');
                    if (item_variant == "By the Yard") {
                        $.ajax({
                            type: 'POST',
                            url: '/cart/change.js',
                            data: data_new,
                            dataType: 'json',
                            success: function() {

                                if (!localStorage.getItem('reload-merge')) {
                                    localStorage.setItem("reload-merge", "true");
                                    // location.reload();
                                }
                            },
                            error: function() {
                                console.error("Error removing item from cart");
                            }
                        });
                    }
                });
            }
        }).catch(error => {
            console.error("Error fetching cart:", error);
        });

}

CartMerge();
});
